import store from 'web/redux/store';
import BaseAPI from 'web/redux/actions/BaseAPI';
import enumList from 'web/utils/enumList';
import {showMessage} from 'web/utils/modalHelper';

/**
 *
 */
export default function useListActions() {
  const fetchAppearances = async ({filters}) => {
    const token = store.getState().auth.token;
    try {
      const response =
        await BaseAPI.getWithAuth('/appearances', filters, token);

      return response.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };

  const fetchAppearance = async ({id}) => {
    const token = store.getState().auth.token;
    try {
      const response =
        await BaseAPI.getWithAuth(`/appearances/${id}`, undefined, token);
      return response.result;
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };

  const updateAppearanceFlgStatus = async ({id, flgStatus}) => {
    const token = store.getState().auth.token;
    try {
      const appearance = await fetchAppearance({id});
      const {skills: origSkills} = appearance;

      await BaseAPI.putWithAuth(`/appearances/${id}`, {
        ...appearance,
        skills: origSkills.map(({condition_id}) => condition_id),
        flgStatus,
      }, token);
    } catch (error) {
      showMessage(
        enumList.messageModalMode.error,
        error?.response?.data?.payload?.message || '發生錯誤',
      );
      throw error;
    }
  };
  return {
    fetchAppearances,
    fetchAppearance,
    updateAppearanceFlgStatus,
  };
}
